module.exports = __webpack_public_path__ + "static/media/SOLUS_LR_MARKER_303.75deg.544e2af0.png";